import React from "react";
import AdvanceTable from "components/common/advance-table/AdvanceTable";
import AdvanceTableFooter from "components/common/advance-table/AdvanceTableFooter";
import AdvanceTableProvider from "providers/AdvanceTableProvider";
import useAdvanceTable from "hooks/useAdvanceTable";

const AppVersionsTable = ({
  appVersions,
  columns,
  totalPages,
  totalElements,
}) => {
  const table = useAdvanceTable({
    data: appVersions,
    columns,
    sortable: true,
    pagination: true,
  });

  return (
    <AdvanceTableProvider {...table}>
      <AdvanceTable
        headerClassName="bg-300 text-nowrap align-middle"
        rowClassName="align-middle white-space-nowrap"
        tableProps={{
          bordered: true,
          striped: true,
          className: "fs-10 mb-0 overflow-hidden",
        }}
      />
      <div className="mt-3">
        <AdvanceTableFooter rowInfo navButtons rowsPerPageSelection />
      </div>
    </AdvanceTableProvider>
  );
};

export default React.memo(AppVersionsTable);
